<template>
    <div style="padding:12px">
         <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
        </div>
        <div class="full-content" :style="`height: ${windowHeight-200}px;overflow: auto;`">
            <div class="wxcep-table">
                <div class="intro-title">步骤1：在页面中先引入如下JS文件（支持https）</div>
                <div>
                    <pre>&lt;script src="https://cdnfile-10043692.file.myqcloud.com/httpsresources/wxLogin.js"&gt;&lt;/script&gt;</pre>
                </div>
                <div class="intro-title">步骤2：在需要使用微信登录的地方实例以下JS对象</div>
                <div>
<pre>var obj = new WxLogin({
    id: "login_container",
    appid: "{{appId}}",
    scope: "snsapi_login",
    redirect_uri: "{{redirect_url}}",
    state: "THIRDWXLOGIN_{{key}}",
    style: "white",
    href: ""
})</pre>
                </div>
                <div class="intro-title">参数说明</div>
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>参数</th>
                        <th>是否必须</th>
                        <th>说明</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            id
                        </td>
                        <td>
                            是
                        </td>
                        <td>
                            第三方页面显示二维码的容器id。
                        </td>
                    </tr>
                    <tr>
                        <td>
                            appid
                        </td>
                        <td>
                            是
                        </td>
                        <td>
                            appid
                        </td>
                    </tr>
                    <tr>
                        <td>
                            scope
                        </td>
                        <td>
                            是
                        </td>
                        <td>
                            应用授权作用域，拥有多个作用域用逗号(,)分隔，网页应用目前仅填写snsapi_login即可。
                        </td>
                    </tr>
                    <tr>
                        <td>
                            redirect_uri
                        </td>
                        <td>
                            是
                        </td>
                        <td>
                            redirect_uri
                        </td>
                    </tr>
                    <tr>
                        <td>
                            state
                        </td>
                        <td>
                            否
                        </td>
                        <td>
                            state
                        </td>
                    </tr>
                    <tr>
                        <td>
                            style
                        </td>
                        <td>
                            否
                        </td>
                        <td>
                            提供"black"、"white"可选，默认为黑色文字描述。
                        </td>
                    </tr>
                    <tr>
                        <td>
                            href
                        </td>
                        <td>
                            否
                        </td>
                        <td>
                            自定义样式链接，第三方可根据实际需求覆盖默认样式。
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import {queryModule, scanLoginIntro} from '@/api/moduleApp';
    import mixin from "@/mixins/windowResize";
    export default {
        name: "moduleAppScanConfigHelper",
        components: {BackTool},
        data() {
            return {
                id: this.$route.query.id,
                appId: '',
                key: '',
                redirect_url: ''
            }
        },
        mixins: [mixin],
        created() {
            scanLoginIntro({
                id: this.id
            })
                .then(data => {
                    this.appId = data.appId;
                    this.key = data.module.key;
                    this.redirect_url = data.redirect_url;

                })
        }
    }
</script>

<style lang="scss" scoped>
    .wxcep-table pre {
        color: #C7254E;
        display: block;
        padding: 9.5px;
        margin: 0 0 10px;
        font-size: 13px;
        line-height: 1.42857143;
        word-break: break-all;
        word-wrap: break-word;
        background-color: #f5f5f5;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
    .top{
        border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
    }
    .intro-title {
        margin: 5px 0;
        font-size: 16px;
        font-weight: bold;
    }
    .detail-info__item span{
        display: inline-block;
        text-align: right;
        width: 100px;
    }
    .detail-info__item p{
        display: inline-block;
    }
    table {
        border-collapse: collapse;
        td, th {
            border: 1px solid #ddd;
            padding: 8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppScanConfigHelper.vue